import { CurrencyPipe } from '@angular/common';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'currencyOrDefault'})
export class CurrencyOrDefaultPipe implements PipeTransform {
  transform(value: any,
            showZero: boolean = false,
            currencyCode: string = 'USD',
            symbolDisplay: boolean = true,
            digits: string = '1.2-2',
            defaultString: string = '—'): string {
    let currencyPipe: CurrencyPipe = new CurrencyPipe('en-US');
    let currencyString: string = defaultString; // default to an em dash

    if (value !== null && typeof value !== 'undefined') {
      if (typeof value === 'string' && !isNaN(parseInt(value, 10))) {
        value = parseInt(value, 10);
      }

      if (typeof value === 'number' && (showZero || value !== 0)) {
        currencyString = currencyPipe.transform(value, currencyCode, symbolDisplay ? 'symbol' : '', digits);
      }
    }

    return currencyString;
  }
}
